import { jsx as i } from "react/jsx-runtime";
import { c as f } from "react/compiler-runtime";
import { AppBar as l } from "@mui/material";
function a(t) {
  const r = f(6);
  let p, e;
  r[0] !== t ? ({
    children: p,
    ...e
  } = t, r[0] = t, r[1] = p, r[2] = e) : (p = r[1], e = r[2]);
  let o;
  return r[3] !== p || r[4] !== e ? (o = /* @__PURE__ */ i(l, { ...e, children: p }), r[3] = p, r[4] = e, r[5] = o) : o = r[5], o;
}
export {
  a as AppBar
};
